/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthorizedSignatoryDto } from './AuthorizedSignatoryDto';
import type { CompanyChangeHistoryEntryDto } from './CompanyChangeHistoryEntryDto';
import type { UserDto } from './UserDto';
export type CompanyRegistrationDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    readonly name?: string;
    readonly streetAddress?: string;
    readonly locality?: string;
    readonly region?: string;
    readonly postalCode?: string;
    readonly country?: string;
    language?: CompanyRegistrationDto.language;
    taxId?: string;
    website?: string;
    readonly email?: string;
    registrationState?: CompanyRegistrationDto.registrationState;
    registrationComment?: string;
    internalNotes?: string;
    /**
     * This property can only be updated by admins.
     */
    refusalReason?: string;
    authorizedSignatory?: AuthorizedSignatoryDto;
    termsOfUseApproved?: boolean;
    attachmentTakenNoteOf?: boolean;
    sendTermsOfUseMail?: boolean;
    readonly registrationChangedByCustomerAt?: string;
    readonly admin?: UserDto;
    readonly latestHistoryEntry?: CompanyChangeHistoryEntryDto;
    latestHistoryChangesAccepted?: boolean;
    infoLetterState?: CompanyRegistrationDto.infoLetterState;
    /**
     * This property can only be updated by admins.
     */
    infoLetterRequestedAt?: string;
    infoLetterSuppliedAt?: string;
    /**
     * This property can only be updated by admins.
     */
    requestInfoLetterReason?: string;
    /**
     * This property can only be used by admins.
     */
    sendInfoLetterReminderMail?: boolean;
    /**
     * This property can only be used by admins.
     */
    accountsReceivableAccount?: string;
    hasThirdPartyContracts?: boolean;
    usageMode?: CompanyRegistrationDto.usageMode;
    readonly activeInCrisp?: boolean;
    readonly beamFullRegistrationDate?: string;
    readonly beamFreeRegistrationDate?: string;
};
export namespace CompanyRegistrationDto {
    export enum language {
        DE = 'DE',
        EN = 'EN',
    }
    export enum registrationState {
        PENDING = 'PENDING',
        IN_APPROVAL = 'IN_APPROVAL',
        IN_PROGRESS = 'IN_PROGRESS',
        CHECK_COMPANY_DATA = 'CHECK_COMPANY_DATA',
        CREATE_INVOICE = 'CREATE_INVOICE',
        UPLOAD_INVOICE = 'UPLOAD_INVOICE',
        ACTIVATE = 'ACTIVATE',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
    }
    export enum infoLetterState {
        REQUESTED = 'REQUESTED',
        SUPPLIED = 'SUPPLIED',
    }
    export enum usageMode {
        BEAM_FULL = 'BEAM_FULL',
        BEAM_FREE = 'BEAM_FREE',
    }
}

